import { gql } from '@apollo/client';
import { query } from '../../../../Services/Gateway/Apollo';

export const GET_MATCH_REASONS = gql`
  query GetMatchReasons($input: GetMatchReasonsInput!) {
    getMatchReasons(input: $input) {
      matchReasons
      matchScores
    }
  }
`;

const getMatchReasonsQuery = async (params) => {
  const { variables } = params;
  try {
    const response = await query({
      query: GET_MATCH_REASONS,
      variables,
    });

    return response.data.getMatchReasons;
  } catch (error) {
    throw new Error(error);
  }
};

export default getMatchReasonsQuery;
